export const LIST_VIEW_KEY = "list-view";
export const TILE_VIEW_KEY = "tile-view";

/**
 * All possible view keys.
 */
export const VIEW_KEYS = [LIST_VIEW_KEY, TILE_VIEW_KEY];

/**
 * Class name for the active view used to manage styles.
 */
export const ACTIVE_VIEW_CLASS = "active-view";

/** One request per column, so each settled term costs four. Matches the residents search. */
export const DASHBOARD_SEARCH_DEBOUNCE_MS = 500;
